import React from 'react';
import { WelcomeProps } from '../../types';
import { getTranslations } from '../../i18n';

import './Welcome.css';

import maw_face from '../../images/maw/maw_talking.gif';

const Welcome: React.FC<WelcomeProps> = ({ name, setName, setPass, mode, setMode, lang, setLang }) => {
  const t = getTranslations(lang);
  const onNameSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const clickSound = document.querySelector('#clickSound') as HTMLAudioElement | null;
    if (clickSound) {
      clickSound.volume = 0.4;
      clickSound.play();
    }
    if (name !== '') {
      setPass(true);
    } else {
      const visitorInput = document.querySelector('input#visitor') as HTMLInputElement | null;
      if (visitorInput) visitorInput.focus();
    }
  };

  const onNoNameSubmit = (e: React.MouseEvent) => {
    e.preventDefault();
    const clickSound = document.querySelector('#clickSound') as HTMLAudioElement | null;
    if (clickSound) {
      clickSound.volume = 0.4;
      clickSound.play();
    }
    setName('');
    setPass(true);
  };

  const handleModeChange = () => {
    if (mode === 'day') {
      setMode('night');
    } else {
      setMode('day');
    }
  };

  const handleLangChange = () => {
    setLang(lang === 'en' ? 'es' : 'en');
  };

  return (
    <div id="welcome">
      <div className="welcome-wrapper pixel-border">
        <div id="theme-selector">
          <button
            className="language-button"
            onClick={handleLangChange}
            aria-label={lang === 'en' ? 'Cambiar a Español' : 'Switch to English'}
            type="button"
            title={lang === 'en' ? 'Cambiar a Español' : 'Switch to English'}
          >
            <span className="lang-flag">{lang === 'en' ? '🇺🇸' : '🇪🇸'}</span>
            <span className="lang-text">{lang === 'en' ? 'EN' : 'ES'}</span>
          </button>
          <button
            className={`theme-toggle ${mode}`}
            onClick={handleModeChange}
            aria-label={mode === 'day' ? t.welcome.switchToDark : t.welcome.switchToLight}
            type="button"
            title={mode === 'day' ? t.welcome.switchToDark : t.welcome.switchToLight}
          >
            <div className="toggle-track">
              <i className="sun icon"></i>
              <i className="moon icon"></i>
              <div className="toggle-thumb"></div>
            </div>
          </button>
        </div>
        <div className="welcome-header-wrapper">
          <div className="avatar-head">
            <img src={maw_face} alt="Maw" />
          </div>
          <h1>{t.welcome.title}</h1>
        </div>
        <h2>{t.welcome.subtitle}</h2>
        <p>{t.welcome.description}</p>

        <form onSubmit={onNameSubmit} className="ui form">
          <div className="field">
            <label htmlFor="visitor">{t.welcome.nameLabel}</label>
            <input
              type="text"
              name="visitor"
              id="visitor"
              placeholder={t.welcome.namePlaceholder}
              onChange={(e) => setName(e.target.value)}
              value={name}
              className="pixel-border-dark"
            />
          </div>
          <input
            type="submit"
            onClick={onNameSubmit}
            className="ui blue button pixel-border-blue"
            value={t.welcome.submitButton}
          />
          <button
            onClick={onNoNameSubmit}
            className="ui button negative pixel-border-red"
          >
            {t.welcome.skipButton}
          </button>
          <span>
            <small>
              {t.welcome.cookieNotice}
            </small>
          </span>
        </form>
      </div>
    </div>
  );
};
export default Welcome;
